import AxiosClient from "../../../Network/AxiosClient";
import { format } from "date-fns";

export const referralService = {
  fetchReferrals: async (currentPage, searchTerm, cancelToken) => {
    const response = await AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/referral_service/v1/service-referral-list`,
      {
        params: { page: currentPage, limit: 10, query: searchTerm },
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        cancelToken: cancelToken,
      }
    );
    return response.data;
  },

  changeStatus: async (campaignId, status) => {
    const response = await AxiosClient.post(
      `${process.env.REACT_APP_API_URL}/api/referral_service/v1/status-change`,
      {
        campaign_id: campaignId,
        final_status: status,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    );
    return response;
  },

  downloadReport: async (campaignId, campaignName) => {
    const response = await AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/reports/v3/service-referral-report`,
      {
        params: { campaign_name: campaignName, report_type: "call_wise" },
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Campaign_Report_${campaignName}_${format(new Date(), "yyyy-MM-dd")}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  },

  getTargetServiceMapping: async () => {
    const response = await AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/referral_service/v1/target-service-mapping`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    );
    return response.data;
  },

  createCampaign: async (formData) => {
    const response = await AxiosClient.post(
      `${process.env.REACT_APP_API_URL}/api/uploads/v1/upload-service-referral`,
      formData,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    );
    return response.data;
  },

  downloadSampleTemplate: async () => {
    const response = await AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/uploads/v1/upload-service-referral`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ServiceReferral_Sample_Template.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  },
};
